import { dutyTypeList } from "constants/dutyType";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getDutyTypeList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.duty_type_list(pageNum, filters);
    dispatch({ type: dutyTypeList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: dutyTypeList,
      payload: error?.response?.data || error,
    });
  }
};
